module.exports = __webpack_public_path__ + "img/level-2.45596f62.png";